<script setup lang="ts">
import {Drawer} from "@/Components/Library";
import {AiChats} from "@/Components/Global";

const visible = defineModel<boolean>("visible");
const {
    group,
    dateFrom = null,
    dateTo = null,
    feedParams = null,
} = defineProps<{
    group: {id: string};
    dateFrom?: string | null;
    dateTo?: string | null;
    feedParams?: {filter: Record<string, unknown>; sort: string[]} | null;
}>();
</script>

<template>
    <Drawer
        v-model:visible="visible"
        position="right"
        header="Analyze Group Responses"
        :closable="true"
        class="w-full max-w-7xl border-l-[1.4rem] !border-l-askr-green-500 !shadow-2xl !shadow-black"
        :modal="false"
    >
        <AiChats
            v-if="group?.id"
            parent-type="group"
            :parent-id="group.id"
            :params="{
                dateFrom: dateFrom,
                dateTo: dateTo,
                filter: feedParams?.filter,
                sort: feedParams?.sort,
            }"
        />
    </Drawer>
</template>
